import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    titleTable: {
      marginTop: "40px"
    },
    root: {
      marginTop: "24px",
      overflowX: "auto",
      width: "100%",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderBottom: 0,
      borderRadius: "2px",
      "& .MuiTableCell-head": {
        "& *": {
          color: theme.palette.grey[600]
        }
      },
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    },
    paginateFooter: {
      background: "rgba(212, 244, 248, 0.8)",
      padding: "12px 20px",
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      borderRight: `1px solid ${theme.palette.grey[300]}`,
      borderLeft: `1px solid ${theme.palette.grey[300]}`
    },
    cellHeader: {
      color: `${theme.palette.grey[900]} !important`
    },
    cellTon: {
      color: `${theme.palette.grey[700]} !important`
    },
    rowFlex: {
      display: "flex",
      gap: 5,
      alignItems: "center"
    },
    cellFirst: {
      paddingLeft: "10px !important",
      paddingRight: "10px !important"
    },
    rowCellBorder: {
      "& td, th": {
        border: `solid 1px ${theme.palette.grey[300]}`,
        padding: 10
      }
    },
    cellNoBorder: {
      borderTop: "0 !important",
      borderLeft: "0 !important",
      borderRight: "0 !important"
    },
    col_1: {
      minWidth: 132
    },
    col_2: {
      minWidth: 76
    },
    col_3: {
      minWidth: 172
    },
    col_4: {
      minWidth: 272
    },
    col_name: {
      minWidth: 192
    },
    col_5: {
      minWidth: 180
    },
    col_6: {
      minWidth: 124
    },
    col_7: {
      minWidth: 180
    },
    col_8: {
      minWidth: 164
    },
    col_9: {
      minWidth: 172
    },
    col_10: {
      minWidth: 106
    },
    col_11: {
      minWidth: 228
    },
    col_12: {
      minWidth: 148
    },
    col_13: {
      minWidth: 172
    },
    col_14: {
      minWidth: 164
    },
    col_15: {
      minWidth: 180
    },
    col_16: {
      minWidth: 164
    },
    col_17: {
      minWidth: 172
    }
  }),
  { name: "TableListLogChange" }
);

export default useStyles;
